import { EvidenceAPI, IdentityProvider } from '../../enums';
import { abortableFetch, useListSource } from '@eas/common-web';

export function getRedirectUrl(
  identityProvider: IdentityProvider,
  redirectPath: string,
  baseEnviiamUrlPath: string
) {
  const serviceUri = encodeURIComponent(
    `${window.location.origin}${redirectPath}`
  );
  const query = [
    `service=${serviceUri}`,
    `client_name=${identityProvider}`,
    'registration=true',
  ];

  if (identityProvider === IdentityProvider.NIA) {
    query.push('extendedNIAAttributes=true');
  }

  return `${baseEnviiamUrlPath}cas/clientredirect?${query.join('&')}`;
}

export function createUser(token: string) {
  return abortableFetch(`${EvidenceAPI.USERS}/registration/idp`, {
    method: 'POST',
    body: token,
  });
}

export function addProviderToUser(ticket: string) {
  return abortableFetch(
    `${EvidenceAPI.USERS}/external-id/create?token=${ticket}`,
    {
      method: 'POST',
    }
  );
}

export function useIdentityProviders() {
  return useListSource<{ id: IdentityProvider; name: string }>({
    url: `${EvidenceAPI.USERS}/external-id/identity-provider/list`,
    method: 'GET',
  });
}
